export default {
  AS: {
    "footer.button.billOfMaterials": "Lista de componentes",
    "footer.button.export": "Exportación",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Distribución Contactar",
    "footer.button.addToWatchlist": "Añadir a la lista de favoritos",
    "footer.button.requestQuote": "Solicitar presupuesto",
    "header.configurator.title": "Configurador",

    "header.links.about.label": "Acerda de asecos ",
    "header.links.about.url":
      "https://www.asecos.com/Sobre-asecos/Sobre-asecos/Sobre-asecos/ES_index_3187.html,",
    "header.links.terms.label": "Términos y condiciones de venta",
    "header.links.terms.url":
      "https://www.asecos.com/Terminos-y-Condiciones-de-Venta/ES_index_1724.html,",
    "header.links.imprint.label": "Aviso legal",
    "header.links.imprint.url":
      "https://www.asecos.com/Impresin/ES_index_1438.html,",
    "header.links.privacy.label": "Política de privacidad",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/ES/ES/poltica-de-privacidad",

    "dialog.requestQuote.title.success": "Solicitud enviada",
    "dialog.requestQuote.title.requestQuote": "Solicitar presupuesto",
    "tab.billOfMaterials.title": "Lista de componentes",
    "tab.configurationSummary.title": "Resumen de la configuración",
    "dialog.requestQuote.title.contactData": "Datos de contacto",
    "dialog.requestQuote.title.companyData": "Datos de la empresa",
    "dialog.requestQuote.label.salutation": "Tratamiento",
    "dialog.requestQuote.select.salutation.option.female": "Sra.",
    "dialog.requestQuote.select.salutation.option.male": "Sr.",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Nombre",
    "dialog.requestQuote.label.lastName": "Apellidos",
    "dialog.requestQuote.label.email": "Correo electrónico",
    "dialog.requestQuote.label.phone": "Teléfono",
    "dialog.requestQuote.label.company": "Empresa",
    "dialog.requestQuote.label.country": "País",
    "dialog.requestQuote.label.postalCode": "Código postal",
    "dialog.requestQuote.label.city": "Localidad",
    "dialog.requestQuote.label.street": "Calle",
    "dialog.requestQuote.label.number": "N.º",
    "dialog.requestQuote.label.contactHours": "Solicito que me llamen",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Por la mañana",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon":
      "Por la tarde",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Aquí puede introducir su distribuidor especializado de referencia (si le es conocido)",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Tratamiento",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Sra.",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Sr.",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Empresa",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Nombre",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Apellidos",
    "dialog.requestQuote.label.specialistRetailer.email": "Correo electrónico",
    "dialog.requestQuote.label.specialistRetailer.city": "Localidad",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/ES/ES/poltica-de-privacidad",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/ES/ES/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=ES",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "He leído <privacyLink>política de privacidad</privacyLink> y la acepto. Además, doy mi consentimiento para el procesamiento, uso y divulgación de mis datos a un distribuidor especializado de acuerdo con el <consentLink>consentimiento</consentLink>.",
    "dialog.requestQuote.label.comment": "Comentario",
    "SubconfigurationNavigation.resetItem": "Restablecer grupo",
    "SubconfigurationNavigation.previousItem": "Atrás",
    "SubconfigurationNavigation.nextItem": "Siguiente",
    "form.field.error.email": "Correo electrónico no válido",
    "form.field.error.phone": "Número de teléfono no válido",
    "validation.required": "Este campo es obligatorio",
    "footer.button.save": "Guardar",
    "footer.button.load": "Cargar",

    "dialog.requestQuote.success.message":
      "Muchas gracias por su interés en asecos y nuestros productos. En los próximos minutos recibirá una confirmación en la dirección de correo electrónico que nos ha facilitado, incluyendo sus datos de configuración en formato PDF y JSON. Con este último, puede volver a abrir su configuración mediante el botón «Cargar». Los productos asecos se venden a través de distribuidores autorizados. Por lo tanto, remitiremos su solicitud a un socio asecos adecuado. Este le preparará una oferta sin compromiso de acuerdo con su configuración y, si es necesario, se pondrá en contacto con usted.",
    "dialog.requestQuote.success.close": "Cerrar",
    "dialog.requestQuote.error.message":
      "Se ha producido un error al enviar su solicitud. Vuelva a intentarlo más tarde.",
  },
};
